(() => {
  'use strict';

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise((resolve, reject) => {
      const area = document.createElement('textarea');
      area.value = value;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();

      try {
        document.execCommand('copy') ? resolve() : reject(new Error('copy failed'));
      } catch (error) {
        reject(error);
      } finally {
        area.remove();
      }
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-iyyakee-copy-code]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const code = String(button.dataset.iyyakeeCopyCode || '').trim();
    if (!code) return;

    const original = button.textContent;

    copyText(code)
      .then(() => {
        button.textContent = 'KOPYALANDI ✓';
        button.setAttribute('aria-label', code + ' indirim kodu kopyalandı');
        window.setTimeout(() => {
          button.textContent = original;
          button.setAttribute('aria-label', code + ' indirim kodunu kopyala');
        }, 1800);
      })
      .catch(() => {
        button.textContent = code;
        window.setTimeout(() => { button.textContent = original; }, 1800);
      });
  }, true);

  document.documentElement.classList.add('iyyakee-brand-ready');
})();
